import React, { useEffect, useState } from 'react';
import './Toast.css';

let toastInstance = null;

export const showToast = (message, duration = 2000) => {
  if (toastInstance) {
    toastInstance(message);
  }
};

const Toast = () => {
  const [message, setMessage] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    toastInstance = (msg) => {
      setMessage(msg);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 2000);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="toast-container">
      <div className="toast-message">{message}</div>
    </div>
  );
};

export default Toast;